import { useSelector } from 'react-redux';
import { useCan } from '../rbac';
import { getShopSellerToken } from '../utils/shop-seller-token';

export interface BrandManagementControls {
  canRename: boolean;
  canDelete: boolean;
}

/**
 * Whether the Rename and Delete brand controls may be shown. Both need the
 * role capability AND a seller login: the rename/delete endpoints accept only
 * the seller token, which invite-only members do not have.
 */
export function useBrandManagementControls(): BrandManagementControls {
  const mayManage = useCan('clients.manage');
  const mayDelete = useCan('clients.delete');
  const hasSellerToken = useSelector(
    (state: any) => getShopSellerToken(state) !== null
  );

  return {
    canRename: mayManage && hasSellerToken,
    canDelete: mayDelete && hasSellerToken,
  };
}
